module.exports = __webpack_public_path__ + "img/medilinkGroupZRY_plan.6af43537.jpg";